import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { PropTypes as PropTypes$1 } from '@micromag/core';
import { getOptimalImageUrl, pascalCase, isTextFilled } from '@micromag/core/utils';
import Link from '@micromag/element-link';
import Text from '@micromag/element-text';

var styles$1 = {"container":"micromag-element-urbania-author-avatar-container","shapeCircle":"micromag-element-urbania-author-avatar-shapeCircle","shape":"micromag-element-urbania-author-avatar-shape"};

var propTypes$1 = {
  image: PropTypes$1.imageElement,
  width: PropTypes.number,
  height: PropTypes.number,
  resolution: PropTypes.number,
  isTag: PropTypes.bool,
  shape: PropTypes.oneOf([null, 'tag', 'circle']),
  className: PropTypes.string,
  shouldLoad: PropTypes.bool
};
var defaultProps$1 = {
  image: null,
  width: 100,
  height: 100,
  resolution: 1,
  isTag: false,
  shape: 'circle',
  className: null,
  shouldLoad: true
};
var Avatar = function Avatar(_ref) {
  var image = _ref.image,
    width = _ref.width,
    height = _ref.height,
    resolution = _ref.resolution,
    shape = _ref.shape,
    isTag = _ref.isTag,
    className = _ref.className,
    shouldLoad = _ref.shouldLoad;
  var imageAtSize = getOptimalImageUrl(image, width, height, {
    resolution: resolution
  });
  var finalShape = shape !== null ? pascalCase(shape) : null;
  return /*#__PURE__*/React.createElement("span", {
    className: classNames([styles$1.container, _defineProperty(_defineProperty(_defineProperty({}, styles$1["shape".concat(finalShape)], finalShape !== null), styles$1.isTag, isTag), className, className !== null)])
  }, /*#__PURE__*/React.createElement("span", {
    className: styles$1.shape,
    style: {
      backgroundImage: shouldLoad ? "url(\"".concat(imageAtSize, "\")") : null
    }
  }));
};
Avatar.propTypes = propTypes$1;
Avatar.defaultProps = defaultProps$1;

var styles = {"container":"micromag-element-urbania-author-container","image":"micromag-element-urbania-author-image","link":"micromag-element-urbania-author-link","right":"micromag-element-urbania-author-right","name":"micromag-element-urbania-author-name","prefix":"micromag-element-urbania-author-prefix","collaborator":"micromag-element-urbania-author-collaborator","collaboratorText":"micromag-element-urbania-author-collaboratorText","isSmall":"micromag-element-urbania-author-isSmall","withoutImage":"micromag-element-urbania-author-withoutImage","withoutBackground":"micromag-element-urbania-author-withoutBackground"};

var _excluded = ["author", "withImage", "withoutLink", "withoutPrefix", "withoutBackground", "isSmall", "linkUnderlineColor", "className", "backgroundClassName", "collaboratorClassName", "shouldLoad"];
var propTypes = {
  author: PropTypes.shape({
    slug: PropTypes.string,
    name: PropTypes$1.textElement,
    image: PropTypes$1.imageElement,
    url: PropTypes.string,
    collaborator: PropTypes$1.textElement
  }),
  withImage: PropTypes.bool,
  withoutLink: PropTypes.bool,
  withoutPrefix: PropTypes.bool,
  withoutBackground: PropTypes.bool,
  isSmall: PropTypes.bool,
  linkUnderlineColor: PropTypes.string,
  className: PropTypes.string,
  backgroundClassName: PropTypes.string,
  collaboratorClassName: PropTypes.string,
  shouldLoad: PropTypes.bool
};
var defaultProps = {
  author: null,
  withImage: true,
  withoutLink: false,
  withoutPrefix: false,
  withoutBackground: false,
  isSmall: false,
  linkUnderlineColor: null,
  className: null,
  backgroundClassName: null,
  collaboratorClassName: null,
  shouldLoad: true
};
var UrbaniaAuthor = function UrbaniaAuthor(_ref) {
  var author = _ref.author,
    withImage = _ref.withImage,
    withoutLink = _ref.withoutLink,
    withoutPrefix = _ref.withoutPrefix,
    withoutBackground = _ref.withoutBackground,
    isSmall = _ref.isSmall,
    linkUnderlineColor = _ref.linkUnderlineColor,
    className = _ref.className,
    backgroundClassName = _ref.backgroundClassName,
    collaboratorClassName = _ref.collaboratorClassName,
    shouldLoad = _ref.shouldLoad,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var _ref2 = author || {},
    _ref2$name = _ref2.name,
    name = _ref2$name === void 0 ? null : _ref2$name,
    _ref2$image = _ref2.image,
    image = _ref2$image === void 0 ? null : _ref2$image,
    _ref2$url = _ref2.url,
    url = _ref2$url === void 0 ? null : _ref2$url,
    _ref2$collaborator = _ref2.collaborator,
    collaborator = _ref2$collaborator === void 0 ? null : _ref2$collaborator;
  var withAvatar = withImage && image !== null;
  var prefix = intl.formatMessage({
    id: "jEK6B8",
    defaultMessage: [{
      "type": 0,
      "value": "By"
    }]
  });
  var authorText = isTextFilled(name) ? /*#__PURE__*/React.createElement(Text, Object.assign({
    className: classNames([styles.name, _defineProperty({}, backgroundClassName, backgroundClassName)])
  }, name)) : null;
  var collaboratorText = isTextFilled(collaborator) ? /*#__PURE__*/React.createElement(Text, Object.assign({
    className: styles.collaboratorText
  }, collaborator, {
    inline: true
  })) : null;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classNames([styles.container, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.isSmall, isSmall), styles.withoutAvatar, withAvatar), styles.withoutImage, !withImage || image === null), styles.withoutBackground, withoutBackground), className, className !== null)])
  }, otherProps), !withoutPrefix ? /*#__PURE__*/React.createElement(Text, Object.assign({}, name, {
    className: classNames([styles.prefix, _defineProperty({}, backgroundClassName, backgroundClassName)]),
    body: "<span>".concat(prefix, "<span>")
  })) : null, withAvatar ? /*#__PURE__*/React.createElement(Avatar, {
    className: styles.image,
    image: image,
    shouldLoad: shouldLoad
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, url !== null && !withoutLink ? /*#__PURE__*/React.createElement(Link, {
    className: styles.link,
    url: url,
    external: true,
    style: {
      backgroundImage: linkUnderlineColor !== null ? "linear-gradient(0deg, ".concat(linkUnderlineColor, " 0, ").concat(linkUnderlineColor, ")") : null
    }
  }, authorText) : /*#__PURE__*/React.createElement("div", null, authorText), collaboratorText !== null ? /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.collaborator, _defineProperty({}, collaboratorClassName, collaboratorClassName)])
  }, collaboratorText !== null ? collaboratorText : null) : null));
};
UrbaniaAuthor.propTypes = propTypes;
UrbaniaAuthor.defaultProps = defaultProps;

export { UrbaniaAuthor as default };
